import { render, staticRenderFns } from "./addReturnShop.page.vue?vue&type=template&id=33365e0e&scoped=true&"
import script from "./addReturnShop.page.vue?vue&type=script&lang=js&"
export * from "./addReturnShop.page.vue?vue&type=script&lang=js&"
import style0 from "./addReturnShop.page.vue?vue&type=style&index=0&id=33365e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33365e0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33365e0e')) {
      api.createRecord('33365e0e', component.options)
    } else {
      api.reload('33365e0e', component.options)
    }
    module.hot.accept("./addReturnShop.page.vue?vue&type=template&id=33365e0e&scoped=true&", function () {
      api.rerender('33365e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/returnShop/addReturnShop.page.vue"
export default component.exports